export default __webpack_public_path__ + "f7619315f7cab51e2059b439e061096c.png";